import { render, staticRenderFns } from "./activity_edit.vue?vue&type=template&id=3d12b6e7&scoped=true"
import script from "./activity_edit.vue?vue&type=script&lang=js"
export * from "./activity_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_edit.vue?vue&type=style&index=0&id=3d12b6e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d12b6e7",
  null
  
)

export default component.exports